import { z } from "zod";

import { eventTypeAppCardZod } from "@calcom/app-store/eventTypeAppCardZod";
import { returningCustomerPricingSchema } from "@calcom/app-store/_utils/payments/returningCustomerPricingSchema";

const paymentOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const paymentOptionsSchema = z.array(paymentOptionSchema);

export const MolliePaymentOptions = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING",
  },
];

type PaymentOption = (typeof MolliePaymentOptions)[number]["value"];
const VALUES: [PaymentOption, ...PaymentOption[]] = [
  MolliePaymentOptions[0].value,
  ...MolliePaymentOptions.slice(1).map((option) => option.value),
];
export const paymentOptionEnum = z.enum(VALUES);

export const appDataSchema = eventTypeAppCardZod.merge(
  z.object({
    price: z.number(),
    currency: z.string(),
    paymentOption: z.string().optional(),
    enabled: z.boolean().optional(),
    returningCustomerPricing: returningCustomerPricingSchema.optional(),
  })
);
export const appKeysSchema = z.object({});
